export const inputBase =
  'h-12 w-full rounded-[10px] border bg-white px-4 text-[16px] text-ink outline-none transition-[border-color,box-shadow] duration-150 ease-out placeholder:text-ink-muted/70 focus:border-brand focus:ring-2 focus:ring-brand/15'

export function inputBorder(hasError: boolean): string {
  return hasError ? 'border-[#C0362C]' : 'border-ink/15 hover:border-ink/30'
}
